import { Schema } from "effect";
import { DatabaseInstance, DatabaseTarget } from "../../api/database/model.ts";
import type { DatabaseBinding, DatabaseCatalog, DatabaseColumn, DatabaseFacet, DatabaseInstance as Instance, DatabaseNamespace } from "../../api/database/model.ts";

export const ExplorerAction = Schema.Union([
  Schema.TaggedStruct("SelectWorkspace", { workspaceId: Schema.NullOr(Schema.String) }),
  Schema.TaggedStruct("Refresh", {}),
  Schema.TaggedStruct("LoadInstances", { namespace: Schema.String, force: Schema.Boolean }),
  Schema.TaggedStruct("LoadFacets", { namespace: Schema.String, instance: DatabaseInstance, force: Schema.Boolean }),
  Schema.TaggedStruct("LoadCatalog", { target: DatabaseTarget, force: Schema.Boolean, openTables: Schema.Array(Schema.String) }),
  Schema.TaggedStruct("LoadColumns", { target: DatabaseTarget, tableName: Schema.String, force: Schema.Boolean }),
  Schema.TaggedStruct("RegisterNamespace", {}),
  Schema.TaggedStruct("RegisterInstance", { namespace: Schema.String }),
  Schema.TaggedStruct("RegisterFacet", { namespace: Schema.String, instance: DatabaseInstance })
]);
export type ExplorerAction = typeof ExplorerAction.Type;
export const RegistrationSettlement = Schema.Struct({ workspaceId: Schema.String, outcome: Schema.Literals(["success", "refused"]), message: Schema.NullOr(Schema.String) });
export type RegistrationSettlement = typeof RegistrationSettlement.Type;
export interface ExplorerSnapshot {
  readonly workspaceId: string | null;
  readonly bindings: readonly DatabaseBinding[];
  readonly namespaces: readonly DatabaseNamespace[];
  readonly instances: ReadonlyMap<string, readonly Instance[]>;
  readonly facets: ReadonlyMap<string, readonly DatabaseFacet[]>;
  readonly catalogs: ReadonlyMap<string, DatabaseCatalog>;
  readonly columns: ReadonlyMap<string, readonly DatabaseColumn[]>;
  readonly loadingKeys: ReadonlySet<string>;
  readonly registering: boolean;
  readonly error: string | null;
  readonly autoOpenCatalogs: ReadonlySet<string>;
}
export const itemKey = (...parts: string[]): string => JSON.stringify(parts);
export const emptyExplorer = (workspaceId: string | null = null, registering = false): ExplorerSnapshot => ({ workspaceId, bindings: [], namespaces: [], instances: new Map(), facets: new Map(), catalogs: new Map(), columns: new Map(), loadingKeys: new Set(), registering, error: null, autoOpenCatalogs: new Set() });
